export class SimilarRegulationFilter {
  similarIndex: string;
  jurisdiction: string[];
  type:string;

  constructor() {
    this.similarIndex = '';
    this.jurisdiction = [];
    this.type='';
  }
}
